import { hFetch } from './hFetch';
import type { UserTaskEntity } from './entity_types/UserTask';

export const listUserTasks = async () => {
  return (await hFetch({ url: '/api/user_tasks' })) as { records: UserTaskEntity[] };
};

export const getUserTask = async ({ id }: { id: number }) => {
  return await hFetch({ url: `/api/user_tasks/${id}` });
};

export const updateUserTask = async ({ id, payload }: { id: number; payload: unknown }) => {
  return await hFetch({ url: `/api/user_tasks/${id}`, method: 'PATCH', payload });
};
